module.exports = __webpack_public_path__ + "static/media/screenmenu.960ebfa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/screenmenu.png
// module id = 1299
// module chunks = 110